define('autonavigation',['jquery', 'core'], function ($, core) {
    var module = {};
    var linkClicked = false;

    module.onAutoNavigationLoad = function (context) {
        var $autoNavigation = context.andFind('.js-auto-navigation'),
            $autoNavInner = $('.sticky-nav-inner');
        if ($autoNavigation.length) {
            var activeSectionId = (window.location.hash || '').replace('#', '');

            function toggleParent() {
                var hideOthers = function () {
                    $('.js-rb-toggle-list', '.js-auto-navigation').removeClass('rb-list-open');
                    $('.js-rb-list', '.js-auto-navigation').removeClass('active-block');
                    $('.js-rb-list', '.js-auto-navigation').hide();
                };

                var parentList = $('a.active-link').parents('.js-rb-list');
                if (parentList.length && parentList.is(":hidden")) {
                    hideOthers();

                    parentList.addClass('active-block');
                    var parentListName = $('a.active-link').parents('.js-rb-list').data('rb-list');
                    var parentListLink = $('.js-rb-toggle-list[data-rb-toggle-list="' + parentListName + '"]');
                    parentListLink.addClass('rb-list-open');
                    parentList.show();
                } else if (parentList.length == 0) {
                    hideOthers();
                }
            }

            function linkClick() {
                if (!$(this).hasClass('js-has-children')) {
                    linkClicked = true;

                    $('a.active-link').removeClass("active-link");
                    $(this).addClass("active-link");

                    $('.active-dropdown').removeClass('active-dropdown');
                    $('.js-trigger-dropdown').removeClass('active-menu');

                    toggleParent();
                }
            };

            function highlightAutoNavigationLinkAndStickNavigation() {

                if (!$('.active-dropdown').length) {
                    //Sticky navigation
                    var windowTop = $(window).scrollTop();
                    var divTop = $('.sidebar-layout-sidebar').offset().top;
                    if (windowTop > divTop) {
                        $autoNavigation.addClass('sticky');
                    } else {
                        $autoNavigation.removeClass('sticky');
                    }

                    //If link clicked, do not execute auto highlight
                    if (linkClicked) {
                        linkClicked = false;
                        return;
                    }

                    //Auto highlight
                    var windowPos = $(window).scrollTop(); // get the offset of the window from the top of page
                    var windowHeight = $(window).height(); // get the height of the window
                    var docHeight = $(document).height();

                    var $sections = $('.js-auto-navigate-level1-heading, .js-auto-navigate-level2-heading');
                    var $reverseSections = $($sections.get().reverse());

                    $reverseSections.each(function (index, value) {
                        var $section = $(value);
                        var titlePos = $section.offset().top; // get the offset of the div from the top of page
                        var titleHeight = $section.height();
                        if (windowPos >= titlePos - titleHeight * 2) {
                            $('a.active-link').removeClass("active-link");

                            var activeLinkItemId = value.id;

                            //If item has children then activate first child
                            if ($section.hasClass('js-auto-navigate-level1-heading')) {
                                var $sectionSubItems = $section.nextUntil('h1.js-auto-navigate-level1-heading', 'h2.js-auto-navigate-level2-heading');
                                if ($sectionSubItems.length > 0) {
                                    var $firstSubItem = $sectionSubItems.first();
                                    activeLinkItemId = $firstSubItem.attr('id');
                                }
                            }

                            var $activeLink = $("a[href='#" + activeLinkItemId + "']");
                            if (!$activeLink.hasClass('active-link')) {
                                $activeLink.addClass("active-link");
                                toggleParent();
                            }

                            // It is not accurate but it keeps up in policies page.
                            $autoNavigation.animate({
                                scrollTop: $activeLink.position().top
                            }, 0);

                            return false;
                        }

                        return true;
                    });

                    //If scrolled to bottom
                    if (windowPos + windowHeight == docHeight) {
                        var $lastSection = $sections.last();
                        var $lastSectionLink = $("a[href='#" + $lastSection.attr('id') + "']");
                        if (!$lastSectionLink.hasClass("active-link")) {
                            $('a.active-link').removeClass("active-link");
                            $lastSectionLink.addClass("active-link");

                            toggleParent();
                        }
                    }
                }
            };

            $('.js-auto-navigate-level1-heading').each(function (level1Index, level1Item) {
                var $level1Item = $(level1Item);
                var level1ItemId = $level1Item.attr('id');
                var toggleListName = "auto-navigation-" + level1Index;

                var level1Link = $('<a></a>');
                level1Link.attr('href', "#" + level1ItemId);
                level1Link.attr('data-rb-toggle-list', toggleListName);
                level1Link.html($level1Item.html());
                level1Link.click(linkClick);

                var $subItems = $level1Item.nextUntil('h1.js-auto-navigate-level1-heading', 'h2.js-auto-navigate-level2-heading');

                var levelItemIsActive = false;
                if (level1ItemId == activeSectionId && $subItems.length == 0) {
                    level1Link.addClass('active-link');
                    levelItemIsActive = true;
                }

                if ($subItems.length) {
                    level1Link.addClass("rb-list-heading").addClass('js-rb-toggle-list').addClass('js-has-children');

                    var level1WrapperDiv = $("<div></div>");
                    level1WrapperDiv.addClass("rb-list-wrapper").addClass('js-rb-list');
                    level1WrapperDiv.attr('data-rb-list', toggleListName);

                    $subItems.each(function (level2Index, level2Item) {
                        var $level2Item = $(level2Item);
                        var level2ItemId = $level2Item.attr('id');

                        var level2Link = $('<a></a>');
                        level2Link.attr('href', "#" + level2ItemId);
                        level2Link.html($level2Item.html());
                        level2Link.click(linkClick);

                        //Select first child link if parent section is active
                        if (level2Index == 0 && level1ItemId == activeSectionId) {
                            level2Link.addClass('active-link');
                            levelItemIsActive = true;
                        } else if (level2ItemId == activeSectionId) {
                            level2Link.addClass('active-link');
                            levelItemIsActive = true;
                        }

                        level1WrapperDiv.append(level2Link);
                    });

                    if (levelItemIsActive) {
                        level1Link.addClass('rb-list-open');
                        level1WrapperDiv.addClass('active-block');
                    }

                    $autoNavInner.append(level1Link);
                    $autoNavInner.append(level1WrapperDiv);
                } else {
                    $autoNavInner.append(level1Link);
                    level1Link.addClass('menu-heading-list');
                }
            });

            //Highlight autonavigation link and stick autonavigation on scroll and window resize
            $(window).off('scroll.autonavigation').on("scroll.autonavigation", function () {
                highlightAutoNavigationLinkAndStickNavigation();
            });

            $(window).off('resize.autonavigation').on('resize.autonavigation', function () {
                highlightAutoNavigationLinkAndStickNavigation();
            });
        }
    };

    module.mobilePoliciesMenu = function (context) {
        var self,
            bodyWrapper = $('body'),
            menuWrapper = $('.sidebar-layout-sidebar');
        $('.js-trigger-dropdown').on('click', function (e) {
            e.preventDefault();
            self = $(this);
            if (self.hasClass('active-menu')) {
                self.removeClass('active-menu');
                menuWrapper.removeClass('active-dropdown');
                bodyWrapper.removeClass('active-dropdown');
            } else {
                self.addClass('active-menu');
                menuWrapper.addClass('active-dropdown');
                bodyWrapper.addClass('active-dropdown');
            }
        });
    };

    // Initialize
    $(document).ready(function () {
        core.scopes.addHandler('*', function (context) {
            module.onAutoNavigationLoad(context);
            module.mobilePoliciesMenu(context);
        });
    });

    return module;
});
